import { render, staticRenderFns } from "./AnnualReturnForms.vue?vue&type=template&id=700b8424&scoped=true&"
import script from "./AnnualReturnForms.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnForms.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnForms.vue?vue&type=style&index=0&id=700b8424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b8424",
  null
  
)

export default component.exports